// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pie-list[data-v-36a5ac10] {\n  margin-bottom: 25px;\n}\n.pie-list .chart-line[data-v-36a5ac10] {\n  height: 280px;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
